import { render } from "./SwissStyleTable.vue?vue&type=template&id=5e85e0b8&scoped=true"
import script from "./SwissStyleTable.vue?vue&type=script&lang=js"
export * from "./SwissStyleTable.vue?vue&type=script&lang=js"

import "./SwissStyleTable.vue?vue&type=style&index=0&id=5e85e0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e85e0b8"]])

export default __exports__